<template>
    <v-dialog :persistent="disableCloseModal" eager v-model="dialog" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
        <v-card >
            <v-toolbar fixed dark color="primary">
                <v-btn v-if="!disableCloseModal" icon dark @click="dialog = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="(!multipleOffices && $vuetify.breakpoint.smAndDown) || $vuetify.breakpoint.mdAndUp">{{stepperTitle}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-select
                    v-if="multipleOffices"
                    :items="provider.institution.branch_offices"
                    return-object
                    :item-text="internal ? 'name' : 'address'"
                    label="Sucursal"
                    color="primary darken-2"
                    style="z-index: 1000; max-width: 400px"
                    hide-details
                    v-model="defaultOffice">
                    <template v-slot:selection="{item}">
                      <div style="width: 90%" class="text-truncate">{{internal ? item.name : item.address}}</div>
                    </template>
                </v-select>
            </v-toolbar>

            <v-sheet class="py-3" />

            <v-card-text class="mt-4 pb-4" style="height: 100%;">
                <appointment-steps
                        v-if="individualProvider && !!provider || ( !individualProvider  && !!office)"
                        :branch-office="defaultOffice"
                        ref="stepper"
                        :hide-nav-controls="true"
                        :default-appointment="defaultAppointment"
                        :allow-modifying="allowModifying"
                        :post-schedule-message="postMessage"
                        :redirect-url="redirectUrl"
                        v-on:close="onClose"
                        v-on:appointment-created="onAppointmentCreated"
                        :provider="provider.id"
                        :internal="internal"
                        :individual-provider="individualProvider"
                        @change:controls="actionButtons = $event"
                         />
            </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                v-show="actionButtons.back.show"
                text
                @click="back"
                :disabled="actionButtons.back.disabled"
            >{{actionButtons.back.label}}</v-btn>
            <v-btn
                color="primary"
                v-show="actionButtons.next.show"
                :loading="actionButtons.next.loading"
                class="mr-0"
                @click="next"
                :disabled="actionButtons.next.disabled"
                depressed
            >
              {{actionButtons.next.label}}
            </v-btn>
          </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>

    import AppointmentSteps from '@/components/appointments/AppointmentSteps'
    import {mapState} from 'vuex'

    export default{
        components: {AppointmentSteps},
        props: {
          internal: {
            type: Boolean,
            default: false
          },
          serviceProvider:{
            type: Object
          },
          branchOffice:{
            type: Object
          },
          disableCloseModal: {
            type: Boolean,
            default: false
          },
          redirectUrl: {
            type: String,
            default: ''
          }
        },
        data(){
            return {
                dialog: false,
                defaultAppointment: null,
                allowModifying: false,
                defaultOffice: null,
                actionButtons: {
                  back: {
                    show: false,
                    disabled: false,
                    loading: false,
                    label: 'Atrás'
                  },
                  next: {
                    show: false,
                    disabled: false,
                    loading: false,
                    label: 'Siguiente'
                  }
                }
            }
        },
        mounted(){
          const vm = this
          if(vm.branchOffice){
            vm.defaultOffice = vm.branchOffice
          }else{
            if(vm.provider && vm.provider.institution && vm.provider.institution.branch_offices.length > 0){
              vm.defaultOffice = vm.provider.institution.branch_offices[0]
            }
          }
        },
        methods: {

            back(){
              const vm = this
              vm.$refs.stepper.back()
            },
            next(){
              const vm = this
              vm.$refs.stepper.next()
            },

            onClose(){
                this.hide()
            },
            onAppointmentCreated(evt){
                this.$emit('appointment-created', evt)
            },
            show(defaultAppointment = null, allowModifying = false){

              const vm = this

                vm.dialog = true
                vm.allowModifying = allowModifying
                if(defaultAppointment){
                    vm.defaultAppointment = defaultAppointment
                }

                setTimeout(function(){
                  vm.$refs.stepper.loadSchedules()
                }, 2000)
            },

            hide(){
                this.dialog = false
            }

        },
        watch:{
            defaultOffice(){
              if(this.$refs.stepper) this.$refs.stepper.reset()
            },
            branchOffice(val){
              const vm = this
              vm.defaultAppointment = val
            },
            dialog(val){
                if(!val){
                    this.defaultAppointment = null
                    this.$refs.stepper.reset()
                }
            }
        },
        computed: {
            ...mapState(['currentProvider', 'currentBranchOffice']),
          postMessage(){
            const vm = this
            return (
                !vm.internal
                && vm.provider
                && vm.provider.settings
                && vm.provider.settings.allow_public_schedule_post_message
                && vm.provider.settings.public_schedule_post_message
            ) || ''
          },
          stepperTitle(){
            const vm = this
            if(vm.defaultAppointment && vm.allowModifying){
              return 'Cambiar Cita'
            }

            return 'Agendar nueva cita'
          },
          multipleOffices(){
            const vm = this
            return vm.provider
                && vm.provider.institution
                && vm.provider.institution.branch_offices
                && vm.provider.institution.branch_offices.length > 1
          },
          individualProvider(){
            var vm = this
            return !!vm.provider && !vm.provider.institution
          },

          office(){
              const vm = this
              return vm.defaultOffice || vm.currentBranchOffice
          },

          provider(){
            const vm = this
            return vm.serviceProvider || vm.currentProvider || null
          }

        }
    }
</script>
